ACC.bundleproducts = {
  selectLabel: '<label class=\'ph-aed_select_title\'>',
  optionSelectClosing: '</option></select>',
  optionGroupStarting: '<optgroup label=\'',
  optionGroupClosing: '</optgroup>',
  mandatoryText: '',
  currentPage: '',
  addToCartForm: '#addToCartForm',
  productname: '.ph-productname',
  entryNumber: '#currentEntryNumber',
  productCode: '#currentProductCode',
  langItem: '.ph-lang-items',
  existingLanguageItems: '#existingLanguageItems',
  existingAedLangCount: '#existingAedLangCount',
  languageConfiguredInCart: false,
  prodQuantity: 0,
  isReconfigured: false,
  configpopupWrapper: '.ph-congifpopup_wrapper',
  aedDataClass: '.ph-aed-data',
  currentIsInnosight: '#currentIsInnosight',
  newSelectOptionClass: '.ph-newselect_options',
  prodVariantsData: '',
  selectedCharacteristics: '',
  inosightWarrantyProduct: '',
  inosightWarrantyCount: '',
  selectBoxWarrantyOptionsClass: '.ph-selectboxvariant.warranty option',
  qualifiedProducts: 'qualifiedProducts',
  selectBoxGeneratedWarrantySelectClass: '.warrantySelect-selectBox-dropdown-menu',
  $prodClickIconOrLink: '',
  addToCartFormClass: '.ph-addtocartform',
  disabledbutton: 'ph-disabledbutton',
  disabledlink: 'ph-disabledlink',
  mandatoryValidationMsg: '<div class="hidden ph-mandatory_validation_text">' + $('#mandatoryValidationMsg').html() + '</div>',
  configErrorBorder: 'ph-config-errorborder',
  bindAll: function() {
    $('a.configure,a.reconfigure').on('click', this.generateConfigurationPopup);
    $(document).on('click', '.ph-decisionpageconfigbutton', this.generateConfigurationPopup);
    $(document).on('click', '.ph-pdpconfigbutton', this.generateConfigurationPopup);

    $('.ph-promocode-button').on('click', this.showVoucherBlock);
    $('.ph-button-cancel').on('click', this.hideVoucherBlock);
    $('.ph-promocode-error-button').on('click', this.hideVoucherBlock);
    $('#recurring-mode').on('change', this.validateRecurringMode);
    $('#recurring-customvalue').on('blur', this.validateRecurringValue);
    $('#recurring-custommode').on('change', this.validateRecurringValue);
    $(document).on('click', '.ph-configureproduct__close', function() {
      $.colorbox.close();
    });
    $(document).on('change', '#languageConfigSelect', function() {
      ACC.bundleproducts.redefineSelecboxProperties(true, false);
    });
    $(document).on('change', '.ph-common-configselect', function() {
      ACC.bundleproducts.applySelectedVariants(false);
      $(this).parent().removeClass(ACC.bundleproducts.configErrorBorder);

      if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
        ACC.bundleproducts.getVariantConfig($(this));
      }
    });
    $(document).on('click', '.ph-configuration-popup .ph-chbox-languageterms', function() {
      ACC.bundleproducts.applySelectedVariants(false);
    });
    $(document).on('click', '.ph-popupconfig_applybtn', function() {
      ACC.bundleproducts.applySelectedVariants(true);
    });
    $(document).on('click', '.ph-popupconfig_cancelbtn', function() {
      ACC.bundleproducts.applySelectedVariants(false);
      ACC.bundleproducts.clearSelectedVariants();
    });
    $('#voucherCode').on('blur', function() {
      if ($(this).val() === '' && $('.ph-promocode-errorlabel').is(':hidden')) {
        $(this).next('.ph-promocode-correctlabel').show();
      } else {
        $(this).next('.ph-promocode-correctlabel').hide();
      }
    });
    $('.ph-promocode-block').find('form#command').submit(function(event) {
      var $voucherCode = $('#voucherCode');

      if ($.trim($voucherCode.val()) === '') {
        $voucherCode.parent().addClass('ph-promocode-emptyinput');
        $('.ph-addpromocode-text').addClass('ph-addpromocode-label');
        $voucherCode.addClass('ph-promocode-border');
        $('.ph-promocode-input .ph-exclamation-mark').show();
        $('.ph-promocode-correctlabel').show();
        $('.ph-promocode-errorlabel').hide();
        event.preventDefault();
      }
    });
    $.extend({
      postJSON: function(url, data, callback) {
        return $.post(url, data, callback, 'json');
      }
    });

    if ($('#promocode-smoothscroll').length > 0) {
      $('html, body').animate({
        scrollTop: $('#recurring-mode').offset().top
      }, 1000);
    }
  },
  languageMsgShowing: function(langSelectBoxValue) {
    var allLangMsg = $('#checkout_configure_products').find('.ph-firstproduct-language__validation');

    if (String($(ACC.bundleproducts.existingAedLangCount).val()) === '0') {
      allLangMsg.show();
    } else {
      var existingAedLang = $('#existingAedLang').val();

      if ((langSelectBoxValue !== '' && langSelectBoxValue !== existingAedLang && existingAedLang !== '') || ACC.bundleproducts.languageConfiguredInCart) {
        allLangMsg.hide();
        $('.ph-existinglanguage__validation').show();
      } else {
        allLangMsg.show();
      }
    }
  },
  redefineSelecboxProperties: function(loadColorBox, prefill) {
    var $this = $('#checkout_configure_products').find('#languageConfigSelect');

    $('.ph-firstproduct-language__validation').hide();
    $('.ph-existinglanguage__validation').hide();
    $('.ph-nonlocalanguage__validation').hide();
    $('.ph-language__termsvalidation').hide();
    $('.ph-configuration-popup').find('.ph-chbox-languageterms').prop('checked', false);
    $('#termsCheckboxEnabled').val('false');

    if ($this.length > 0) {
      ACC.bundleproducts.languageMsgShowing($this.val());

      if ($this.find('option:selected').attr('isdealer') === 'true') {
        $('.ph-nonlocalanguage__validation').show();

        if (prefill === true) {
          $('.ph-configuration-popup').find('.ph-chbox-languageterms').prop('checked', true);
        }

        $('#termsCheckboxEnabled').val('true');
      }

      if (loadColorBox) {
        $.colorbox.resize({
          height: '70%'
        });
      }
    }
  },
  setProductDetails: function($this) {
    $(ACC.bundleproducts.productCode).val($this.attr('data-productcode'));
    $(ACC.bundleproducts.entryNumber).val($this.attr('data-entry-number'));
    $('#currentIsLumify').val($this.attr('data-isLumify'));
    $(ACC.bundleproducts.currentIsInnosight).val($this.attr('data-isInnosight'));
    $('#currentPage').val($this.attr('data-page'));
  },
  setInnerHtml: function(productCode) {
    var $itemRow = $('#cartitem_' + productCode),
        itemImageUrl = $itemRow.find('.product_image').find('.ph-freqorderedproduct__image').attr('src'),
        itemProductUrl = $itemRow.find(ACC.bundleproducts.productname).attr('href'),
        itemProductName = $itemRow.find(ACC.bundleproducts.productname).text(),
        itemProductCtn = $itemRow.find('.ph-productctn').html(),
        aedImageHtml = '';

    if (ACC.bundleproducts.currentPage === 'plp') {
      $itemRow = $('#decisionpageitem' + productCode);
      itemImageUrl = $itemRow.find('.ph-decisionpage__image').find('.ph-freqorderedproduct__image').attr('src');
      itemProductUrl = $itemRow.find('.ph-decisionpage__content').find('.productMainLink').attr('href');
      itemProductName = $itemRow.find(ACC.bundleproducts.productname).text();
      itemProductCtn = $itemRow.find(ACC.bundleproducts.productname).attr('data-prod');
    } else if (ACC.bundleproducts.currentPage === 'pdp') {
      $itemRow = $(document).find('#productDetailUpdateable');
      itemImageUrl = $itemRow.find('.ph-prod_image_main').find('li:first-child>img').attr('src');
      itemProductUrl = window.location.href;
      itemProductName = $itemRow.find('.ph-pdp_product_name').text();
      itemProductCtn = productCode;
    }

    aedImageHtml = aedImageHtml + '<div class="ph-col-12 ph-col-md-3  ph-float-left ph-aedleft_image  ph-pr-0">';
    aedImageHtml = aedImageHtml + '<a href="' + itemProductUrl + '"><div class="ph-p-0 ph-text-center"><img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="';
    aedImageHtml = aedImageHtml + itemImageUrl + '" alt="' + itemProductName + '" title="' + itemProductName + '"></div></a>';
    aedImageHtml = aedImageHtml + '</div><div class=" ph-col-12  ph-col-md-9 ph-float-left ph-aedright_content ph-pl-2"><div class="ph-prodname"><a href="';
    aedImageHtml = aedImageHtml + itemProductUrl + '">' + itemProductName + '</a></div><div class="ph-productctn">';
    aedImageHtml = aedImageHtml + itemProductCtn + '</div><div class="ph-aed-data ph-col-12 ph-p-0 ph-float-left"></div></div>';

    $('#checkout_configure_products').html(aedImageHtml);
  },
  processesVariantData: function(data) {
    function compareValue(a, b) {
      if (a.value < b.value) {
        return -1;
      }

      if (a.value > b.value) {
        return 1;
      }

      return 0;
    }

    var returnData = {},
        sortableData = [],
        sortingValue = 0;

    $.each(data, function(k, v) {
      returnData[k] = v.sort(compareValue);

      if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
        if (v.length > 0 && v[v.length - 1].sort) {
          sortingValue = v[v.length - 1].sort;
        }

        sortableData.push({
          sortValue: sortingValue,
          itemValue: returnData[k],
          itemKey: k
        });
      }
    });

    if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
      sortableData.sort(function(a, b) {
        return a.sortValue - b.sortValue;
      });
      returnData = {};
      $.each(sortableData, function(k, v) {
        returnData[v.itemKey] = v.itemValue;
      });
    }

    ACC.bundleproducts.prodVariantsData = returnData;

    return returnData;
  },
  generateConfigurationPopup: function() {
    var productCode = $(this).attr('data-productcode'),
        entryNumber = $(this).attr('data-entry-number');

    if ($(this).hasClass('configure') || $(this).hasClass('reconfigure')) {
      ACC.bundleproducts.isReconfigured = true;
    }

    ACC.bundleproducts.currentPage = $(this).attr('data-page');
    ACC.bundleproducts.configMandatoryText = $('#configMandatoryText').text();
    ACC.bundleproducts.setProductDetails($(this));
    ACC.bundleproducts.disableProdClickAndSetQuantity($(this));

    if (ACC.bundleproducts.currentPage === 'cart' && $('.ph-aed-langprod__selected').length > 0) {
      var existingLanguageItems = '';

      $(ACC.bundleproducts.existingLanguageItems).find(ACC.bundleproducts.langItem).html(existingLanguageItems);

      var existingAedLangCount = 0;

      $('.ph-aed-langprod__selected').each(function() {
        var cartItemNumber = $(this).attr('cartItemNumber');

        if (cartItemNumber !== entryNumber) {
          existingLanguageItems = existingLanguageItems + ', ' + $(this).val();
          existingAedLangCount = parseInt(existingAedLangCount, 10) + parseInt(1, 10);
          $('#existingAedLang').val($(this).attr('aedSelectedLanguage'));
        }
      });
      $(ACC.bundleproducts.existingAedLangCount).val(existingAedLangCount);
      existingLanguageItems = existingLanguageItems.replace(/^,/, '');
      $(ACC.bundleproducts.existingLanguageItems).find(ACC.bundleproducts.langItem).append(existingLanguageItems);
    }

    ACC.bundleproducts.redefineSelecboxProperties(false, false);
    ACC.bundleproducts.setInnerHtml(productCode);
    ACC.bundleproducts.getCharacteristicsAjaxCall(productCode);
  },
  disableProdClickAndSetQuantity: function($this) {
    ACC.bundleproducts.$prodClickIconOrLink = $this;

    if (ACC.bundleproducts.currentPage === 'cart') {
      $this.addClass(ACC.bundleproducts.disabledlink);
    } else {
      if (ACC.bundleproducts.currentPage === 'plp') {
        ACC.product.addToCartIconToLoaderIcon($this.parents(ACC.bundleproducts.addToCartFormClass));
      } else if (ACC.bundleproducts.currentPage === 'pdp') {
        $this.addClass(ACC.bundleproducts.disabledbutton);
      }

      ACC.bundleproducts.prodQuantity = $this.parents('form').find('.qty').val();
    }
  },
  getCharacteristicsAjaxCall: function(productCode) {
    var changeUrl = encodeURI($('.ph-getCharacteristicsUrl').text() + '?productCode=' + productCode);

    if (ACC.bundleproducts.currentPage === 'cart') {
      changeUrl = changeUrl + '&entryNumber=' + $(ACC.bundleproducts.entryNumber).val();
      $('.ph-loader__default').show();
    }

    $.getJSON(changeUrl, ACC.bundleproducts.generateAEDSelectBox)
      .fail(function() {
        setTimeout(function() {
          ACC.product.closeCartPopup(ACC.bundleproducts.$prodClickIconOrLink.parents(ACC.bundleproducts.addToCartFormClass));
        }, 3000);
        ACC.bundleproducts.$prodClickIconOrLink.removeClass(ACC.bundleproducts.disabledbutton);
        ACC.bundleproducts.$prodClickIconOrLink.removeClass(ACC.bundleproducts.disabledlink);
      });
  },
  aedOptionIteration: function(items, options) {
    var optionsHtml = options;

    items.forEach(function(item) {
      var priceFormated = '',
          itemValue = item.value,
          itemLabel = item.value,
          itemDescription = '',
          itemsHolder = {};

      if (item.description) {
        itemDescription = item.description;
      }

      if (item.name !== 'Language' && item.name !== 'Localization' && item.addPrice && item.addPrice.formattedValue !== 'undefined') {
        priceFormated = '&nbsp;(' + item.addPrice.formattedValue + ')&nbsp;';
      }

      if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
        itemValue = item.code + ':' + item.value;
        itemLabel = itemDescription;

        if (priceFormated !== '' && item.addPrice.value === 0) {
          priceFormated = '';
        }
      }

      itemsHolder.itemLabel = itemLabel;
      itemsHolder.itemValue = itemValue;
      itemsHolder.itemDescription = itemDescription;
      itemsHolder.priceFormated = priceFormated;
      optionsHtml = ACC.bundleproducts.constructIndividualOptionsHtml(optionsHtml, item, itemsHolder);
    });

    return optionsHtml;
  },
  constructIndividualOptionsHtml: function(optionsHtmlUntilNow, item, itemsHolder) {
    var optionsHtml = optionsHtmlUntilNow + '<option isdealer=\'' + item.isDealer + '\' itemname=\'' + item.name + '\' itemcode=\'' + item.code;

    if (item.qualifiedProducts) {
      optionsHtml = optionsHtml + '\' qualifiedProducts=\'' + item.qualifiedProducts.toLocaleString();
    }

    optionsHtml = optionsHtml + '\' title=\'' + itemsHolder.itemDescription + '\' value=\'' + itemsHolder.itemValue + '\'>' + itemsHolder.itemLabel;

    if ($('#showConfigPrice').val() === 'true') {
      optionsHtml = optionsHtml + itemsHolder.priceFormated;
    }

    optionsHtml = optionsHtml + '</option>';

    return optionsHtml;
  },
  languageSelectbox: function(productVariants) {
    var languageVariantsOption = '';
    var localLanguageItems = productVariants.filter(function(productVariant) {
      return productVariant.isDealer !== true && (productVariant.name === 'Language' || productVariant.name === 'Localization') && productVariant.isMandatory === true;
    });
    var nonlocalLanguageItems = productVariants.filter(function(productVariant) {
      return productVariant.isDealer === true && (productVariant.name === 'Language' || productVariant.name === 'Localization') && productVariant.isMandatory === true;
    });
    var labelItem = ACC.bundleproducts.selectLabel + $('#languageSelectBoxLabel').val() + '</label>';

    languageVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'>';
    languageVariantsOption = languageVariantsOption + '<select id="languageConfigSelect" class="ph-mandatory_configselect ph-common-configselect" isMandatory="true">';

    languageVariantsOption = languageVariantsOption + ACC.bundleproducts.languageTemp(localLanguageItems, nonlocalLanguageItems);

    languageVariantsOption = languageVariantsOption + '<option disabled selected value=\'\'>' + ACC.bundleproducts.mandatoryText + ACC.bundleproducts.optionSelectClosing;
    languageVariantsOption = languageVariantsOption + labelItem + '<span class="ph-exclamation-mark"></span>' + ACC.bundleproducts.mandatoryValidationMsg + '</div>';

    $(ACC.bundleproducts.aedDataClass).append(languageVariantsOption);
    ACC.bundleproducts.validationMsgFunction();
  },
  languageTemp: function(localLanguageItems, nonlocalLanguageItems) {
    var localLanguageGroupLabel = $('#localLanguageGroupLabel').val(),
        nonLocalLanguageGroupLabel = $('#nonLocalLanguageGroupLabel').val(),
        temp = '';

    if (localLanguageItems.length > 0 && nonlocalLanguageItems.length > 0) {
      temp = temp + ACC.bundleproducts.optionGroupStarting + localLanguageGroupLabel + '\'>';
      temp = ACC.bundleproducts.aedOptionIteration(localLanguageItems, temp);
      temp = temp + ACC.bundleproducts.optionGroupClosing;

      temp = temp + ACC.bundleproducts.optionGroupStarting + nonLocalLanguageGroupLabel + '\'>';
      temp = ACC.bundleproducts.aedOptionIteration(nonlocalLanguageItems, temp);
      temp = temp + ACC.bundleproducts.optionGroupClosing;
    } else if (localLanguageItems.length > 0 && nonlocalLanguageItems.length === 0) {
      temp = ACC.bundleproducts.aedOptionIteration(localLanguageItems, temp);
    } else if (localLanguageItems.length === 0 && nonlocalLanguageItems.length > 0) {
      temp = ACC.bundleproducts.aedOptionIteration(nonlocalLanguageItems, temp);
    }

    return temp;
  },
  validationMsgFunction: function() {
    var existingLang = $('#existingLanguageMsgOne').html() + $(ACC.bundleproducts.existingLanguageItems).html() + $('#existingLanguageMsgTwo').html(),
        aedDataHtml = '<div class="ph-firstproduct-language__validation hidden ph-float-left">' + $('#firstProductLanguageMsg').html() + '</div>';

    aedDataHtml = aedDataHtml + '<div class="ph-existinglanguage__validation hidden ph-float-left">' + existingLang + '</div>';
    aedDataHtml = aedDataHtml + '<div class="ph-nonlocalanguage__validation hidden ph-float-left">' + $('#nonLocaLanguageValidationMsg').html() + '</div>';

    $(ACC.bundleproducts.aedDataClass).append(aedDataHtml);
  },
  optionalVariantBuilding: function(productVariants, variantName) {
    var optionalVariantsOption = '';
    var optionalItems = productVariants.filter(function(productVariant) {
      return productVariant.isMandatory === false;
    });

    if (optionalItems.length > 0) {
      var labelItem = ACC.bundleproducts.selectLabel + variantName + '</label>';

      optionalVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class="ph-optional_configselect ph-common-configselect" isMandatory="false">';
      optionalVariantsOption = ACC.bundleproducts.aedOptionIteration(optionalItems, optionalVariantsOption);
      optionalVariantsOption = optionalVariantsOption + '<option selected value=\'\'>' + $('#selectOptionOptional').val() + ACC.bundleproducts.optionSelectClosing;
      optionalVariantsOption = optionalVariantsOption + labelItem + '</div>';
    }

    $(ACC.bundleproducts.aedDataClass).append(optionalVariantsOption);
  },
  mandatoryVariantBuilding: function(productVariants, variantName) {
    var mandatoryVariantsOption = '';
    var mandatoryItems = productVariants.filter(function(productVariant) {
      return productVariant.isMandatory;
    });

    if (mandatoryItems.length > 0) {
      var labelItem = ACC.bundleproducts.selectLabel + variantName + ACC.bundleproducts.configMandatoryText + '</label>';

      mandatoryVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class="ph-mandatory_configselect ph-common-configselect"  isMandatory="true">';
      mandatoryVariantsOption = ACC.bundleproducts.aedOptionIteration(mandatoryItems, mandatoryVariantsOption);
      mandatoryVariantsOption = mandatoryVariantsOption + '<option disabled selected value=\'\'>' + ACC.bundleproducts.mandatoryText + ACC.bundleproducts.optionSelectClosing;
      mandatoryVariantsOption = mandatoryVariantsOption + labelItem + '<span class="ph-exclamation-mark"></span>' + ACC.bundleproducts.mandatoryValidationMsg + '</div>';
    }

    $(ACC.bundleproducts.aedDataClass).append(mandatoryVariantsOption);
  },
  optionalMutualVariantBuilding: function(optionalMutualVariantsOptionParam, labelItemOmvParam, optMutualCountParam, productVariants) {
    var returnableValues = [],
        optionalMutualVariantsOption = optionalMutualVariantsOptionParam,
        labelItemOmv = labelItemOmvParam,
        optMutualCount = optMutualCountParam,
        optionalMutualVariants = productVariants.filter(function(productVariant) {
          return productVariant.mutuallyExclusive && productVariant.isMandatory === false;
        });

    if (optionalMutualVariants.length > 0) {
      optMutualCount = optMutualCount + 1;

      if (labelItemOmv === '') {
        labelItemOmv = optionalMutualVariants[0].name;
      }

      if (optionalMutualVariantsOption === '') {
        optionalMutualVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class=" ph-common-configselect" isMandatory="false">';
      } else {
        optionalMutualVariantsOption = optionalMutualVariantsOption + ACC.bundleproducts.optionSelectClosing;
      }

      optionalMutualVariantsOption = optionalMutualVariantsOption + ACC.bundleproducts.optionGroupStarting + optionalMutualVariants[0].name + '\'>';
      optionalMutualVariantsOption = ACC.bundleproducts.aedOptionIteration(optionalMutualVariants, optionalMutualVariantsOption);
      optionalMutualVariantsOption = optionalMutualVariantsOption + ACC.bundleproducts.optionSelectClosing;
    }

    returnableValues.optionalMutualVariantsOption = optionalMutualVariantsOption;
    returnableValues.labelItemOmv = labelItemOmv;
    returnableValues.optMutualCount = optMutualCount;

    return returnableValues;
  },
  mandatoryMutualVariantBuilding: function(mandatoryMutualVariantsOptionParam, labelItemMmvParam, mandMutualCountParam, productVariants) {
    var returnableValues = [],
        mandatoryMutualVariantsOption = mandatoryMutualVariantsOptionParam,
        labelItemMmv = labelItemMmvParam,
        mandMutualCount = mandMutualCountParam,
        mandatoryMutualVariants = productVariants.filter(function(productVariant) {
          return productVariant.mutuallyExclusive && productVariant.isMandatory;
        });

    if (mandatoryMutualVariants.length > 0) {
      mandMutualCount = mandMutualCount + 1;

      if (labelItemMmv === '') {
        labelItemMmv = mandatoryMutualVariants[0].name;
      }

      if (mandatoryMutualVariantsOption === '') {
        mandatoryMutualVariantsOption = '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'><select class=" ph-common-configselect" isMandatory="true">';
      } else {
        mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + ACC.bundleproducts.optionSelectClosing;
      }

      mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + ACC.bundleproducts.optionGroupStarting + mandatoryMutualVariants[0].name + '\'>';
      mandatoryMutualVariantsOption = ACC.bundleproducts.aedOptionIteration(mandatoryMutualVariants, mandatoryMutualVariantsOption);
      mandatoryMutualVariantsOption = mandatoryMutualVariantsOption + ACC.bundleproducts.optionSelectClosing;
    }

    returnableValues.mandatoryMutualVariantsOption = mandatoryMutualVariantsOption;
    returnableValues.labelItemMmv = labelItemMmv;
    returnableValues.mandMutualCount = mandMutualCount;

    return returnableValues;
  },
  configVariantBuilding: function(productVariants, variantName) {
    var variantsOption = '',
        isMandatoryItem = productVariants.filter(function(productVariant) {
          return productVariant.isMandatory === true;
        }),
        isMutuallyExclusive = productVariants.filter(function(productVariant) {
          return productVariant.mutuallyExclusive === true;
        }),
        labelItem = ACC.bundleproducts.selectLabel + variantName,
        selectOptionOptional = $('#selectOptionOptional').val(),
        variantAlias = ACC.bundleproducts.variantAlias(variantName),
        selectClassAppendName = 'Select',
        mandatoryValidationMsg = '';

    if (isMandatoryItem.length > 0) {
      labelItem = labelItem + ACC.bundleproducts.configMandatoryText;
      mandatoryValidationMsg = ACC.bundleproducts.mandatoryValidationMsg;
    }

    // Following 'if' commented as any 'if' added in configVariantBuilding function exceeds 20 and causes grunt issues
    /* If (variantName === 'Warranty') {
         selectClassAppendName = 'warrantySelect';
       } */

    labelItem = labelItem + '</label>';
    variantsOption = '<div class=\'ph-group_selectbox_items ph-selectboxvariant ' +
    variantAlias + ' ph-icon-arrow-down\'><select class="ph-optional_configselect ph-common-configselect ' +
    variantAlias + selectClassAppendName + '" isMandatory="';
    variantsOption = variantsOption + String(isMandatoryItem.length > 0) + '"';

    if (isMutuallyExclusive.length === 0) {
      variantsOption = variantsOption + ' multiple="multiple"';
    }

    variantsOption = variantsOption + '>';
    variantsOption = ACC.bundleproducts.aedOptionIteration(productVariants, variantsOption);

    if (variantName === 'Warranty') {
      variantsOption = variantsOption + '>';
    } else {
      variantsOption = variantsOption + '<option selected value=""';
    }

    if (isMandatoryItem.length === 0 && isMutuallyExclusive.length === 0) {
      variantsOption = variantsOption + ' disabled>' + selectOptionOptional;
    } else if (isMandatoryItem.length > 0 || isMutuallyExclusive.length === 0) {
      variantsOption = variantsOption + ' disabled>' + $('#selectOptionMandatory').val();
    } else {
      variantsOption = variantsOption + '>' + selectOptionOptional;
    }

    variantsOption = variantsOption + ACC.bundleproducts.optionSelectClosing + labelItem +
     '<span class="ph-forconf ph-exclamation-mark"></span>' + mandatoryValidationMsg + '</div>';
    $(ACC.bundleproducts.aedDataClass).append(variantsOption);
  },
  appendWarrantyToVariantMap: function(mapData) {
    if (!mapData.warrantyMap) {
      return mapData.variantMap;
    }

    var warrantyOptions = mapData.warrantyMap;

    if ($.isArray(warrantyOptions) === false) {
      warrantyOptions = [warrantyOptions];
    }

    $.each(warrantyOptions, function(key, warrantyVariant) {
      warrantyVariant.description = warrantyVariant.name;
      warrantyVariant.addPrice = warrantyVariant.price;
      warrantyVariant.mutuallyExclusive = true;
      warrantyVariant.value = 'Warranty';
      warrantyVariant.sort = 10;
    });

    mapData.variantMap.Warranty = warrantyOptions;

    return mapData.variantMap;
  },
  addSelectedWarranty: function(mapData) {
    if (mapData.selectedWarrantyMap) {
      mapData.selectedWarranty = mapData.selectedWarrantyMap;
    }

    if (mapData.selectedVariants && Array.isArray(mapData.selectedVariants) && mapData.selectedWarranty) {
      mapData.selectedVariants.push({
        code: mapData.selectedWarranty
      });
    }

    return mapData.selectedVariants;
  },
  generateAEDSelectBox: function(mapData) {
    $('#checkout_configure_products').find(ACC.bundleproducts.aedDataClass).html('');
    ACC.bundleproducts.mandatoryText = $('#selectOptionMandatory').val();

    var optionalMutualVariantsOption = '',
        labelItemOmv = '',
        optMutualCount = 0,
        mandatoryMutualVariantsOption = '',
        labelItemMmv = '',
        mandMutualCount = 0,
        productAllVariants = {};

    mapData.variantMap = ACC.bundleproducts.appendWarrantyToVariantMap(mapData);

    if (ACC.bundleproducts.currentPage === 'cart') {
      productAllVariants = ACC.bundleproducts.processesVariantData(mapData.variantMap);
    } else {
      productAllVariants = ACC.bundleproducts.processesVariantData(mapData.variantMap);

      var existingAedLangCount = 0,
          existingLanguageItems = [];

      $.each(mapData.cartData.entries, function(k, v) {
        existingLanguageItems.push(v.product.name);
        existingAedLangCount = parseInt(existingAedLangCount, 10) + parseInt(1, 10);

        var curProdChar = v.productCharacteristics;

        if (curProdChar.length > 0) {
          $.each(curProdChar, function(prodCharInd, prodCharVal) {
            if (prodCharVal.name === 'Language') {
              ACC.bundleproducts.languageConfiguredInCart = true;
            }
          });
        }
      });
      $(ACC.bundleproducts.entryNumber).val(mapData.cartData.totalItems);
      $(ACC.bundleproducts.existingAedLangCount).val(existingAedLangCount);
      $(ACC.bundleproducts.existingLanguageItems).find(ACC.bundleproducts.langItem).html(existingLanguageItems.join(', '));
    }

    $.each(productAllVariants, function(variantName, productVariantsObject) {
      var productVariants = Object.keys(productVariantsObject).map(function(k) {
        return productVariantsObject[k];
      });

      if (variantName === 'Language' || variantName === 'Localization') {
        ACC.bundleproducts.languageSelectbox(productVariants);
      } else if ($('#currentIsLumify').val() === 'false') {
        ACC.bundleproducts.configVariantBuilding(productVariants, variantName);
      } else {
        ACC.bundleproducts.mandatoryVariantBuilding(productVariants, variantName);

        var optionalMutualReturned = ACC.bundleproducts.optionalMutualVariantBuilding(optionalMutualVariantsOption, labelItemOmv, optMutualCount, productVariants);

        optionalMutualVariantsOption = optionalMutualReturned.optionalMutualVariantsOption;
        labelItemOmv = optionalMutualReturned.labelItemOmv;
        optMutualCount = optionalMutualReturned.optMutualCount;

        var mandatoryMutualReturned = ACC.bundleproducts.mandatoryMutualVariantBuilding(mandatoryMutualVariantsOption, labelItemMmv, mandMutualCount, productVariants);

        mandatoryMutualVariantsOption = mandatoryMutualReturned.mandatoryMutualVariantsOption;
        labelItemMmv = mandatoryMutualReturned.labelItemMmv;
        mandMutualCount = mandatoryMutualReturned.mandMutualCount;
      }
    });

    ACC.bundleproducts.variantDisplayOptions(mapData);
    ACC.bundleproducts.configPopupColorbox(mapData);
  },
  configPopupColorbox: function(mapData) {
    if (ACC.bundleproducts.isReconfigured && mapData.selectedVariants) {
      mapData.selectedVariants = ACC.bundleproducts.addSelectedWarranty(mapData);
      ACC.bundleproducts.prefilSelectedVariants(mapData);
      ACC.bundleproducts.isReconfigured = false;
    } else {
      ACC.bundleproducts.loadColorBoxConfig();
    }
  },
  warrantySettingAtPopupLoad: function() {
    if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
      var $warOptions = $(ACC.bundleproducts.selectBoxWarrantyOptionsClass),
          largestQualifiedProducts = 0,
          genericWarrantyCode = '',
          isReconfiguredProduct = Array.isArray(ACC.bundleproducts.selectedCharacteristics);

      $warOptions.each(function(index, elem) {
        var qProds = elem.getAttribute(ACC.bundleproducts.qualifiedProducts),
            shouldHideWarrantyOption = true,
            warrCode = elem.getAttribute('itemcode');

        /* If reconfigure, we hide options based on already selected variants. If not reconfigure, then on popup load we simply select warranty which has most number of codes in
        qualifiedProducts. not a business rule. Think if marketSeg is used for warrantySelection. Then in popup if user selects sysCore first, warrantyoptions would be shown.
            To atleast show something in warrantyOptions we are doing this logic in else condition. nothing more. */
        if (isReconfiguredProduct && qProds) {
          /*  SelectedWarranty is already applied in warrantyOptions. also in warranty dropdown all options are being shown.
             so we will be matching all selectedCharacteristics codes for each warranty option's qualifiedProducts field. and based on that hide warranty options */
          ACC.bundleproducts.selectedCharacteristics.every(function(item) {
            if (qProds.includes(item.code)) {
              shouldHideWarrantyOption = false;

              return false;
            }

            return true;
            // Above returns are used for 'every' function call to continue execution if 'return true', else exit out of loop if 'return false'. Not a return of warrantySettings
          });

          if (shouldHideWarrantyOption) {
            $(ACC.bundleproducts.selectBoxGeneratedWarrantySelectClass + ' a[rel*=' + warrCode + ']').last().hide();
          }
        } else if (qProds && qProds.length > largestQualifiedProducts) {
          // Here qProds is a string containing comma seperated codes.
          largestQualifiedProducts = elem.getAttribute(ACC.bundleproducts.qualifiedProducts);
          genericWarrantyCode = elem.getAttribute('value');
        }
      });

      if (!isReconfiguredProduct && genericWarrantyCode) {
        $('.warranty select').selectBox('value', genericWarrantyCode);
      }
    }
  },
  loadColorBoxConfig: function() {
    $('.ph-loader__default').hide();

    var popupHeight = 'auto',
        maxHeight = '90%',
        resizeHeight = '70%';

    if ($(window).width() < 768) {
      popupHeight = '100%';
      maxHeight = '100%';
    }


    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $.colorbox({
      inline: true,
      href: '#popup_checkout_configure_products',
      height: popupHeight,
      width: '100%',
      maxWidth: 640,
      maxHeight: maxHeight,
      overlayClose: false,
      scrolling: true,
      escKey: false,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('.ph-configureproduct__buttons').css({
          position: 'sticky',
          bottom: '0'
        });
        ACC.bundleproducts.$prodClickIconOrLink.removeClass(ACC.bundleproducts.disabledbutton);
        ACC.bundleproducts.$prodClickIconOrLink.removeClass(ACC.bundleproducts.disabledlink);
        $('html').addClass('ph-hideoverflow__configpopup');
        $('#cboxContent').addClass('ph-cbox-content');
        $('#cboxLoadedContent').addClass('ph-cbox-loadedcontent');
        $('#cboxLoadingGraphic').hide();
        $('#cboxLoadingOverlay').hide();
        ACC.bundleproducts.redefineSelecboxProperties(false, false);
        ACC.common.searchSelectInit();
        ACC.bundleproducts.multiSelectCheck();
        ACC.bundleproducts.warrantySettingAtPopupLoad();

        if ($('#checkout_configure_products').height() + 150 < window.innerHeight) {
          resizeHeight = $('#checkout_configure_products').height() + 150 + 'px';
        } else {
          resizeHeight = '80%';
        }

        $.colorbox.resize({
          height: resizeHeight
        });
      },
      onClosed: function() {
        ACC.bundleproducts.languageConfiguredInCart = false;
        $('html').removeClass('ph-hideoverflow__configpopup');
        $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
        setTimeout(function() {
          ACC.product.closeCartPopup(ACC.bundleproducts.$prodClickIconOrLink.parents(ACC.bundleproducts.addToCartFormClass));
        }, 3000);
      }
    });
    $('#cboxLoadingGraphic').show();
    $('#cboxLoadingOverlay').show();
  },
  multiSelectCheck: function() {
    if ($('.ph-congifpopup_wrapper select[multiple]').length > 0) {
      ACC.multiselect.initMultiSelect($('.ph-congifpopup_wrapper select[multiple]'));
    }
  },
  prefilSelectedVariants: function(mapData) {
    var selectedVariants = mapData.selectedVariants;

    if (selectedVariants) {
      ACC.bundleproducts.selectedCharacteristics = selectedVariants;
      $.each(selectedVariants, function(i) {
        $('#checkout_configure_products').find('.ph-group_selectbox_items select').find('option[itemcode="' + selectedVariants[i].code + '"]').prop('selected', true);
      });
    }

    ACC.bundleproducts.redefineSelecboxProperties(false, true);
    $('#cboxLoadingGraphic').hide();
    $('#cboxLoadingOverlay').hide();

    if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true' && ACC.bundleproducts.currentPage === 'cart') {
      if (mapData.initialConfig && Array.isArray(mapData.initialConfig)) {
        mapData.initialConfig.forEach(function(item) {
          var variantAlias = ACC.bundleproducts.variantAlias(item);

          $(ACC.bundleproducts.configpopupWrapper).find('.' + variantAlias + ' select').trigger('change');
        });
      }
    }

    ACC.bundleproducts.loadColorBoxConfig();
  },
  applySelectedVariants: function(sendAjax) {
    var isValidationSuccess = true,
        jsonObj = [],
        termsAndCondition = false,
        acceptedLanguage = '',
        termsError = false;

    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $('.ph-language__termsvalidation').hide();

    if ($('.ph-configuration-popup').find('.ph-chbox-languageterms').is(':checked') && $('#termsCheckboxEnabled').val() === 'true') {
      termsAndCondition = true;
    } else if ($('#termsCheckboxEnabled').val() === 'true') {
      termsError = true;
      isValidationSuccess = false;
    }

    if ($('#languageConfigSelect').length > 0) {
      acceptedLanguage = $('#languageConfigSelect').val();
    }

    var jsonData = ACC.bundleproducts.createJson(isValidationSuccess, sendAjax, termsAndCondition, acceptedLanguage);

    isValidationSuccess = jsonData.isValid;
    jsonObj = jsonData.jsonObj;


    if (isValidationSuccess === true && sendAjax === true) {
      ACC.bundleproducts.sendingSelectedVariants(jsonObj, termsAndCondition, acceptedLanguage);
    } else if (isValidationSuccess === false && sendAjax === true) {
      $('.ph-configureproduct__buttons').find('.ph-error-message').show();

      if (termsError) {
        $('.ph-language__termsvalidation').show();
      }

      $.colorbox.resize({
        height: '70%'
      });
    }
  },
  createJson: function(isValidationSuccess, sendAjax, termsAndCondition, acceptedLanguage) {
    var isValid = isValidationSuccess,
        jsonObj = [];

    $('#checkout_configure_products').find('.ph-group_selectbox_items select').each(function() {
      var itemVal = $(this).val(),
          items = {
            value: ACC.bundleproducts.getItemValue(itemVal)
          };

      if ($(this).parent().is(':visible') && $(this).attr('isMandatory') === 'true' && (items.value === '' || items.value === null)) {
        if (sendAjax) {
          $(this).parent().addClass(ACC.bundleproducts.configErrorBorder);
        }

        isValid = false;
      }

      if (items.value && ($(this).parent().is(':visible') || $(this).parent().hasClass('warranty'))) {
        if (ACC.bundleproducts.currentPage !== 'cart') {
          items.quantity = ACC.bundleproducts.getItemQty();
        }

        items.code = ACC.bundleproducts.getItemCode($(this));
        items.product = $(ACC.bundleproducts.productCode).val();
        items.entryNumber = $(ACC.bundleproducts.entryNumber).val();
        items.termsAndCondition = termsAndCondition;
        items.acceptedLanguage = acceptedLanguage;
        jsonObj.push(items);
      }
    });

    return {
      isValid: isValid,
      jsonObj: jsonObj
    };
  },
  getItemValueFiltered: function(itemVal) {
    if (!itemVal) {
      return '';
    }

    return itemVal.substring(itemVal.lastIndexOf(':') + 1);
  },
  getItemValue: function(itemVal) {
    var finalValue = '';

    if ($.isArray(itemVal)) {
      finalValue = itemVal.map(ACC.bundleproducts.getItemValueFiltered);
      finalValue = finalValue.join(',');
    } else {
      finalValue = ACC.bundleproducts.getItemValueFiltered(itemVal);
    }

    return finalValue;
  },
  getItemCode: function($this) {
    var itemsCode = '';

    if ($this.prop('multiple')) {
      var itemCode = [];

      $this.find('option:selected').each(function() {
        itemCode.push($(this).attr('itemcode'));
      });
      itemsCode = itemCode.join(',');
    } else {
      itemsCode = $this.find('option:selected').attr('itemcode');
    }

    return itemsCode;
  },
  getItemQty: function() {
    return ACC.bundleproducts.prodQuantity;
  },
  sendingSelectedVariants: function(jsonObj, termsAndCondition, acceptedLanguage) {
    if (jsonObj.length === 0) {
      var items = {};

      if (ACC.bundleproducts.currentPage !== 'cart') {
        items.quantity = ACC.bundleproducts.getItemQty();
      }

      items.value = '0';
      items.code = '0';
      items.product = $(ACC.bundleproducts.productCode).val();
      items.entryNumber = $(ACC.bundleproducts.entryNumber).val();
      items.termsAndCondition = termsAndCondition;
      items.acceptedLanguage = acceptedLanguage;
      jsonObj.push(items);
    }

    $('#cboxLoadingGraphic').show();
    $('#cboxLoadingOverlay').show();
    $.ajax({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      type: 'POST',
      url: document.querySelector('.ph-setSelectedCharacteristics').textContent,
      dataType: 'json',
      data: JSON.stringify(jsonObj),
      success: function(cartResult, statusText, xhr) {
        $('#cboxLoadingGraphic').hide();
        $('#cboxLoadingOverlay').hide();
        parent.$.colorbox.close();

        if (ACC.bundleproducts.currentPage === 'cart') {
          window.location.reload();
        } else if (ACC.bundleproducts.currentPage !== 'cart') {
          if ($(ACC.bundleproducts.addToCartForm + $(ACC.bundleproducts.productCode).val())) {
            ACC.product.addToCartLoaderToCheckIcon(ACC.bundleproducts.$prodClickIconOrLink.parents(ACC.bundleproducts.addToCartFormClass));
            ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, $(ACC.bundleproducts.addToCartForm + $(ACC.bundleproducts.productCode).val()));
          } else {
            ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, $(ACC.bundleproducts.addToCartForm));
          }
        }
      }
    });
  },
  clearSelectedVariants: function() {
    $('.ph-configuration-popup').find('.ph-newselect_options').remove();
    $('.ph-group_selectbox_items select').each(function() {
      $(this).parent().removeClass(ACC.bundleproducts.configErrorBorder);

      if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true' && $(this).parent().hasClass('warranty')) {
        $(this).val($(this).find('option:first').val());
        $(this).selectBox('refresh');
      } else if ($(this).prop('multiple')) {
        $(this).selectBox('destroy');
        $(this).val([]);
        $(this).selectBox();
      } else {
        $(this).val('');
        $(this).selectBox('refresh');
      }
    });
    $('#checkout_configure_products').find('.ph-firstproduct-language__validation').hide();
    $('#checkout_configure_products').find('.ph-existinglanguage__validation').hide();
    $('#checkout_configure_products').find('.ph-nonlocalanguage__validation').hide();
    $('#checkout_configure_products').find('.ph-language__termsvalidation').hide();
    $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
    $('.ph-configuration-popup').find('.ph-chbox-languageterms').prop('checked', false);
    ACC.bundleproducts.multiSelectCheck();
  },
  validateconfiguration: function(url) {
    if (ACC.configit.configItFlag === 'true' && $('.ph-configit_warrantyvalidation .mandat').length > 0) {
      $('.ph-configitWarrantyErrrorMessage').show();
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    } else if (ACC.configit.configItFlag === 'true' && $('.ph-configit_validation .mandat').length > 0) {
      $('#congifErrrorMessage').show();
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    } else if (ACC.configit.configItFlag === 'true' && $('.configflag').length > 0) {
      ACC.bundleproducts.validateconfigurationFn(url);
    } else {
      ACC.bundleproducts.validateconfigurationFn(url);
    }
  },
  validateconfigurationFn: function(url) {
    var validateflag = 1;

    $('.configflag').each(function() {
      if ($(this).val() === 'false' && $(this).siblings('.allFalseFlag').val() === 'true') {
        $(this).parents('tr').addClass('config_error');
        validateflag = 0;
        $('#congifErrrorMessage').show();
        $('html, body').animate({
          scrollTop: 0
        }, 'slow');
      }
    });

    if (validateflag === 1 && ACC.bundleproducts.validateRecurringValue() === true) {
      if (url === '') {
        ACC.bundleproducts.validateRecurringValue();
        $('#checkout-form').submit();
        /* For cart page */
      } else {
        location.href = escape(url);
        /* For cartPunchout page */
      }
    }
  },
  validateRecurringMode: function() {
    var recurringMode = $('#recurring-mode').val();

    $('.ph-custom-recurring-option').hide();

    if (recurringMode === 'custom') {
      $('.ph-custom-recurring-option').show();
    }

    $('.ph-recurring-errormsg').hide();
    $('.ph-recurring-info').hide();
    $('#recurring-customvalue').removeClass('ph-error-border');
    $('#recurring-custommode').removeClass('ph-error-border');
    $('#recurring-custommode').parent().find('.selectBox-dropdown').removeClass('ph-error-border');
    $('.ph-recurring-customvalue .ph-exclamation-mark').hide();
  },
  validateRecurringValue: function() {
    var validationStatus = true;

    $('.ph-recurring-errormsg').hide();
    $('.ph-recurring-info').hide();
    $('#recurring-customvalue').removeClass('ph-error-border');
    $('#recurring-custommode').removeClass('ph-error-border');
    $('#recurring-custommode').parent().find('.selectBox-dropdown').removeClass('ph-error-border');
    $('.ph-recurring-customvalue .ph-exclamation-mark').hide();

    if ($('#recurring-mode').val() === 'custom') {
      ACC.bundleproducts.inputMaxMinFilter($('#recurring-customvalue'));
      validationStatus = ACC.bundleproducts.recurringCustomEnabled();
    } else {
      $('#send-recurring-customvalue').val('');
      $('#send-recurring-custommode').val('');
    }

    $('#send-recurring-mode').val($('#recurring-mode').val());

    return validationStatus;
  },
  recurringCustomEnabled: function() {
    var validationStatus = true,
        $recurringCustomvalue = $('#recurring-customvalue'),
        $recurringCustommode = $('#recurring-custommode');

    if ($recurringCustomvalue.val() === '0' || $recurringCustomvalue.val() === '') {
      $recurringCustomvalue.val(0).addClass('ph-error-border');
      $('.ph-recurring-errormsg').show();
      $('.ph-recurring-customvalue .ph-exclamation-mark').show();
      validationStatus = false;
    }

    if ($recurringCustommode.val() === '' || $recurringCustommode.val() === null) {
      $('.ph-recurring-errormsg').show();
      $recurringCustommode.addClass('ph-error-border');
      $recurringCustommode.parent().find('.selectBox-dropdown').addClass('ph-error-border');
      validationStatus = false;
    }

    if (validationStatus === true) {
      var recurringInfo = $('#recurring-info-hidden').val();

      recurringInfo = recurringInfo.replace('[RecurringValue]', $recurringCustomvalue.val());
      recurringInfo = recurringInfo.replace('[RecurringMode]', $('#recurring-custommode').find('option:selected').text());
      $('#recurring-info').text(recurringInfo);
      $('.ph-recurring-info').show();
    }

    $('#send-recurring-customvalue').val($recurringCustomvalue.val());
    $('#send-recurring-custommode').val($recurringCustommode.val());

    return validationStatus;
  },
  resetRecurringMode: function() {
    $('#recurring-mode').val('once');
    $('#recurring-customvalue').val(0);
    $('#send-recurring-mode').val($('#recurring-mode').val());
    $('.ph-custom-recurring-option').hide();
    ACC.bundleproducts.validateRecurringValue();
  },
  inputMaxMinFilter: function(numberInputField) {
    var maxValue = numberInputField.attr('max'),
        minValue = numberInputField.attr('min');

    if (parseInt(numberInputField.val(), 10) > parseInt(maxValue, 10)) {
      numberInputField.val(maxValue);
    } else if (parseInt(numberInputField.val(), 10) < parseInt(minValue, 10)) {
      numberInputField.val(minValue);
    }
  },
  showVoucherBlock: function(event) {
    event.preventDefault();
    $('.ph-promocode-link').hide();
    $('.ph-promocode-block').show();
    $('#voucherCode').val('').focus();
  },
  hideVoucherBlock: function(event) {
    event.preventDefault();
    $('#voucherCode').val('');
    $('#voucherCode').removeClass('ph-promocode-border');
    $('.ph-promocode-input .ph-promocode-errorlabel').hide();
    $('.ph-promocode-input .ph-promocode-correctlabel').show();
    $('.ph-promocode-input .ph-exclamation-mark').hide();
    $('.ph-promocode-link').show();
    $('.ph-promocode-block').hide();
    $('.ph-addpromocode-text').hide();
    $('.ph-promocode-error').hide();
  },
  variantAlias: function(variantName) {
    var regex = new RegExp('[^a-zA-Z0-9]', 'ig');

    return variantName.replace(regex, '').toLowerCase();
  },
  variantDisplayOptions: function(mapData) {
    if ($(ACC.bundleproducts.currentIsInnosight).val() === 'true') {
      var $popupParent = $(ACC.bundleproducts.configpopupWrapper);

      if (mapData.initialConfig && Array.isArray(mapData.initialConfig)) {
        $popupParent.find('.ph-selectboxvariant').hide();

        mapData.initialConfig.forEach(function(item) {
          var variantAlias = ACC.bundleproducts.variantAlias(item);

          $popupParent.find('.' + variantAlias).addClass('ph-d-block');
        });
      }
    }
  },
  getVariantConfig: function(selectedElement) {
    var itemCode = selectedElement.find('option:selected').attr('itemcode'),
        prodVariantConfig = '';

    $.each(ACC.bundleproducts.prodVariantsData, function(k, v) {
      var configItem = v.filter(function(item) {
        return item.code === itemCode && item.config;
      });

      if (configItem.length > 0 && configItem[0]) {
        prodVariantConfig = configItem[0].config;
      }
    });

    if (prodVariantConfig) {
      prodVariantConfig = JSON.parse(prodVariantConfig);
      ACC.bundleproducts.applyVariantConfig(prodVariantConfig);
    }

    var doesInfluenceWarranty = ACC.bundleproducts.doesSelectionInfluenceWarranty(itemCode);

    if (doesInfluenceWarranty === 'true') {
      ACC.bundleproducts.updateWarranty(itemCode);
    }
  },
  applyVariantConfig: function(prodVariantConfig) {
    var $popupParent = $(ACC.bundleproducts.configpopupWrapper),
        variantNames = Object.keys(prodVariantConfig);

    $popupParent.find('.ph-selectboxvariant').hide();

    variantNames.forEach(function(variantName) {
      var variantAlias = ACC.bundleproducts.variantAlias(variantName),
          isMutuallyExclusive = prodVariantConfig[variantName];

      $popupParent.find('.' + variantAlias).show();

      if ($popupParent.find('.' + variantAlias + ' select').attr('multiple') && isMutuallyExclusive) {
        ACC.bundleproducts.changeToSingleSelect(variantName, $popupParent.find('.' + variantAlias + ' select'));
      } else if (!$popupParent.find('.' + variantAlias + ' select').attr('multiple') && !isMutuallyExclusive) {
        ACC.bundleproducts.changeToMultiSelect(variantName, $popupParent.find('.' + variantAlias + ' select'));
      }
    });

    if ($popupParent.find('.warranty option').length > 1) {
      $popupParent.find('.warranty').show();
    }
  },
  doesSelectionInfluenceWarranty: function(itemcode) {
    /* Idea is if say sysCore defines warranty options then every sysCore must have at least one warranty which it should have sysCore code in qualifiedproducts field.
    if user selects any other type ofoption like market Seg, then no match will found for its code in any warranty's qualifiedProducts field.
    So if it returns false, no need to update warranty options. */
    var $warOptions = $(ACC.bundleproducts.selectBoxWarrantyOptionsClass),
        doesInfluence = 'false';

    $warOptions.each(function(index, elem) {
      var qProds = elem.getAttribute(ACC.bundleproducts.qualifiedProducts);

      if (qProds && qProds.includes(itemcode)) {
        doesInfluence = 'true';

        return false;
      }

      return true;
    /* Above returns are used to simply stop '.each' function execution. these are not the return value of doesSelectionInfluenceWarranty function. */
    });

    return doesInfluence;
  },
  updateWarranty: function(itemcode) {
    var $warOptions = $(ACC.bundleproducts.selectBoxWarrantyOptionsClass),
        isfirstOccurenceSetInOptions = false;

    $warOptions.each(function(index, elem) {
      var qProds = elem.getAttribute(ACC.bundleproducts.qualifiedProducts),
          warrCode = elem.getAttribute('itemcode');

      if (qProds && qProds.includes(itemcode)) {
        if (!isfirstOccurenceSetInOptions) {
          var warrValue = elem.getAttribute('value');

          $('.warranty select').selectBox('value', warrValue);
          isfirstOccurenceSetInOptions = true;
        }

        $(ACC.bundleproducts.selectBoxGeneratedWarrantySelectClass + ' a[rel*=' + warrCode + ']').last().show();
      } else {
        $(ACC.bundleproducts.selectBoxGeneratedWarrantySelectClass + ' a[rel*=' + warrCode + ']').last().hide();
      }
    });
  },
  changeToSingleSelect: function(variantName, $selectObj) {
    $selectObj.val('');
    $selectObj.removeAttr('multiple');

    if (ACC.bundleproducts.currentPage === 'cart') {
      var existingValues = ACC.bundleproducts.reConfigurableValue(variantName);

      if (existingValues.length > 0) {
        $selectObj.find('option[itemcode="' + existingValues[0] + '"]').prop('selected', true);
      }
    }

    var selectBoxNewSelectOption = $selectObj.parent().find(ACC.bundleproducts.newSelectOptionClass);

    if (selectBoxNewSelectOption.length > 0) {
      selectBoxNewSelectOption.remove();
    }

    $selectObj.parent().removeClass(ACC.bundleproducts.configErrorBorder).removeClass('ph-multiselect_wrapper');

    $selectObj.selectBox('destroy');
    $selectObj.selectBox({
      mobile: 'true'
    });
  },
  changeToMultiSelect: function(variantName, $selectObj) {
    $selectObj.val([]);
    $selectObj.attr({
      multiple: 'multiple'
    });

    if (ACC.bundleproducts.currentPage === 'cart') {
      var existingValues = ACC.bundleproducts.reConfigurableValue(variantName);

      existingValues.forEach(function(existingValue) {
        $selectObj.find('option[itemcode="' + existingValue + '"]').prop('selected', true);
      });
    }

    var selectBoxNewSelectOption = $selectObj.parent().find(ACC.bundleproducts.newSelectOptionClass);

    if (selectBoxNewSelectOption.length > 0) {
      selectBoxNewSelectOption.remove();
    }

    $selectObj.parent().removeClass(ACC.bundleproducts.configErrorBorder).addClass('ph-multiselect_wrapper');

    $selectObj.selectBox('destroy');
    $selectObj.selectBox({
      mobile: 'true'
    });
    ACC.multiselect.initMultiSelect($selectObj);
  },
  reConfigurableValue: function(variantName) {
    var returnArray = [],
        selectedCharacteristics = ACC.bundleproducts.selectedCharacteristics.filter(function(item) {
          return variantName === item.name;
        });

    selectedCharacteristics.forEach(function(item) {
      returnArray.push(item.code);
    });

    return returnArray;
  }
};
$(document).ready(function() {
  ACC.bundleproducts.bindAll();
  $(document).on('click', '.ph-configuration-popup ul.ph-newselect_options a', function() {
    ACC.bundleproducts.applySelectedVariants(false);
    $(this).parents('.ph-group_selectbox_items').removeClass(ACC.bundleproducts.configErrorBorder);
  });
});
